<template lang="pug">
  transition(
    name="modal"
  )
    .modal-mask(
      @click="onClickMask($event)"
    )
      .modal-wrapper
        .modal.modal_house-editor(
          @click="onClickWrapper($event)"
        )
          .modal__close
            button.modal-button-close(
              @click="onCloseModal()"
            )
              img(src="@/assets/images/icons/modal-button-close.svg")
          .modal__body
            .house-editor
              .house-editor__title
                h2.title {{title}}
              .house-editor__form
                .form
                  .form__elem
                    .form-elem(
                    :class="{'form-elem_error':fieldsErrors.name.value}"
                    )
                      .form-elem__title Название
                      .form-elem__body
                        input.input.input_full(
                        maxlength="128"
                        v-model="fields.name"
                        @input="resetError('name')"
                        )
                  .form__elem
                    .form-elem(
                    :class="{'form-elem_error':fieldsErrors.capacity.value}"
                    )
                      .form-elem__title Количество мест
                      .form-elem__body
                        input.input.input_full(
                        maxlength="128"
                        v-model="fields.capacity"
                        @input="resetError('capacity')"
                        ref="capacity"
                        )
                  .form__elem
                    .form-elem
                      .form-elem__body
                        button.button.button_paint-main.button_full(
                        @click.prevent="onSaveHouse()"
                        )
                          .button__text {{buttonText}}
                      .form-elem__error(
                        v-if="currentErrorMessage.length > 0"
                      ) {{currentErrorMessage}}

</template>

<script>
import {mapActions} from "vuex";
import SimpleSelectForm from "../simpleSelectForm/SimpleSelectForm";
import Inputmask from "inputmask";

export default {
  name: "CampHouseEditorModal",
  components: {
    SimpleSelectForm,
    Inputmask
  },
  props: {
    currentHouse: {
      type: Object,
      default: () => ({})
    },
    camp: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      fields: {
        capacity: "",
        name: ""
      },
      fieldsErrors: {
        name: {
          value: false,
          message: "Введите название"
        },
        capacity: {
          value: false,
          message: "Введите количество мест"
        }
      },
      currentErrorMessage: "",
      capacityMask: new Inputmask("integer", {
        placeholder: "",
        allowMinus: false,
        rightAlign: false,
        max: 32000
      })
    };
  },
  computed: {
    mode() {
      if (this.currentHouse) {
        return "edit";
      }
      return "create";
    },
    buttonText() {
      if (this.mode === "edit") {
        return "Обновить";
      }
      return "Добавить";
    },
    title() {
      if (this.mode === "edit") {
        return "Редактирование корпуса";
      }
      return "Добавление корпуса";
    }

  },
  methods: {
    ...mapActions(["createCampHouse", "updateCampHouse"]),
    onClickMask() {
      this.onCloseModal();
    },
    onClickWrapper(e) {
      e.stopPropagation();
    },
    onCloseModal() {
      this.$emit("close");
    },
    changeHouse(data, type) {
      this.fields[type] = data;
      this.resetError(type);
    },
    resetError(field) {
      this.fieldsErrors[field].value = false;
      this.currentErrorMessage = "";
    },
    validation() {
      const errors = [];
      if (this.fields.name.length === 0) {
        errors.push("name");
      }
      if (this.fields.capacity.length === 0) {
        errors.push("capacity");
      }
      if (errors.length > 0) {
        errors.forEach(err => {
          this.fieldsErrors[err].value = true;
        });
        this.currentErrorMessage = this.fieldsErrors[errors[0]].message;
        return false;
      }
      return true;
    },
    onSaveHouse() {
      if (!this.validation()) {
        return false;
      };
      const data = {
        name: this.fields.name,
        capacity: this.fields.capacity,
        camp: this.camp
      };
      if (this.mode === "edit") {
        this.updateCampHouse({
          data: data,
          id: this.currentHouse.id
        }).then(res => {
          if (res.status === 200) {
            this.$emit("add-camp-house");
            this.$emit("close");
          } else if (res.status === 400) {
            if (res.data.capacity) {
              this.fieldsErrors.capacity.value = true;
              this.currentErrorMessage = "Неверно заполнено поле";
            }
            if (res.data.non_field_errors[0].code === "invalid") {
              this.fieldsErrors.capacity.value = true;
              this.currentErrorMessage = res.data.non_field_errors[0].message;
            }
          } else {
            alert("Ошибка сервера!");
          }
        });
      } else if (this.mode === "create") {
        this.createCampHouse(data).then(res => {
          if (res.status === 201) {
            this.$emit("add-camp-house");
            this.$emit("close");
          } else if (res.status === 400) {
            if (res.data.capacity) {
              this.fieldsErrors.capacity.value = true;
              this.currentErrorMessage = "Неверно заполнено поле";
            }
            if (res.data.non_field_errors[0].code === "invalid") {
              this.fieldsErrors.capacity.value = true;
              this.currentErrorMessage = res.data.non_field_errors[0].message;
            }
          } else {
            alert("Ошибка сервера!");
          }
        });
      }
    }
  },
  mounted() {
    this.capacityMask.mask(this.$refs.capacity);
    if (this.mode === "edit") {
      this.fields.name = this.currentHouse.name;
      this.fields.capacity = this.currentHouse.capacity;
    }
  }
};
</script>
